import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthProviderLocation,
	GetHealthProviderLocationModel,
	GetHealthProviderLocationParams,
} from 'domain/usecases/private/booking-flow/health';

export class RemoteGetHealthProviderLocation implements GetHealthProviderLocation {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthProviderLocationModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthProviderLocationParams): Promise<GetHealthProviderLocationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
